import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { ApiDataResponse, BaseApiDataResponse } from '../Models/ApiData';
import {
    Engin,
    EnginDetailsApiDataResponse,
    EnginListOrder,
    EnginListResponse,
} from '../Models/Engins/Engin';
import { BaseDataService } from './Base/BaseDataService';

export const EnginEndpoints = {
    ENGINS: '/api/v1/back/engins',
    ENGIN: (enginId: string) => `/api/v1/back/engins/${enginId}`,
    UPDATE_ENGIN: (enginId: string) => `/api/v1/back/engins/${enginId}`,
    CREATE_ENGIN: '/api/v1/back/engins',
    EXPORT_ENGIN_LIST: '/api/v1/back/engins/export',
};

export interface IEnginDataService {
    listEngin: (
        params: {
            search?: string;
            order?: EnginListOrder;
            is_actif?: boolean;
        },
        cts: XHRRequestCanceler
    ) => Promise<EnginListResponse>;

    getEngin: (cts: XHRRequestCanceler, enginId: string) => Promise<EnginDetailsApiDataResponse>;

    updateEngin: (
        enginId: string,
        engin: Engin,
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;

    createEngin: (engin: Engin, cts: XHRRequestCanceler) => Promise<ApiDataResponse<string>>;
}

class EnginDataService extends BaseDataService implements IEnginDataService {
    listEngin = async (
        params: {
            search?: string;
            order?: EnginListOrder;
            is_actif?: boolean;
        },
        cts: XHRRequestCanceler
    ) => {
        return this.get<EnginListResponse>(EnginEndpoints.ENGINS, cts, {
            params,
        });
    };

    getEngin = async (cts: XHRRequestCanceler, enginId: string) => {
        return this.get<EnginDetailsApiDataResponse>(EnginEndpoints.ENGIN(enginId), cts);
    };

    updateEngin = async (enginId: string, engin: Engin, cts: XHRRequestCanceler) => {
        const body = {
            ...engin,
        };
        return this.patch(EnginEndpoints.UPDATE_ENGIN(enginId), body, cts);
    };

    createEngin = async (engin: Engin, cts: XHRRequestCanceler) => {
        const body = {
            ...engin,
        };
        return this.post<ApiDataResponse<string>>(EnginEndpoints.CREATE_ENGIN, body, cts);
    };
}

const EnginDataServiceName = 'EnginDataService';
export { EnginDataService, EnginDataServiceName };
